import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d9105fac"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "add-view-notes" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-md-11" }
const _hoisted_4 = {
  id: "listViewNotes",
  class: "note-list txtLeft scrollBar"
}
const _hoisted_5 = { class: "text-muted" }
const _hoisted_6 = { class: "font-weight-bold" }
const _hoisted_7 = { class: "action bg-info text-white p-1 rounded" }
const _hoisted_8 = { class: "shift" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "font-weight-bold" }, "Note:", -1))
const _hoisted_10 = { style: {"padding-left":"10px","font-size":"1rem"} }
const _hoisted_11 = { class: "text-muted" }
const _hoisted_12 = { class: "font-weight-bold" }
const _hoisted_13 = { class: "row" }
const _hoisted_14 = { class: "col-md-11" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_16 = {
  id: "lblRemaining",
  class: "card-title txtLeft"
}
const _hoisted_17 = {
  id: "remaining",
  class: "text-muted"
}
const _hoisted_18 = {
  key: 0,
  class: "card-body position-relative",
  style: {"overflow":"auto"}
}
const _hoisted_19 = { class: "text-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_neu_button = _resolveComponent("neu-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          (_ctx.notesData != null && _ctx.notesData.length > 0 && _ctx.isAssignmentNoteTemplate)
            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.notesData, (notes) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "note",
                  key: notes
                }, [
                  _createElementVNode("div", null, [
                    _createElementVNode("span", _hoisted_5, _toDisplayString(notes.createDate) + " ", 1),
                    _createElementVNode("span", _hoisted_6, _toDisplayString(notes.createUser), 1),
                    _createTextVNode(" -  "),
                    _createElementVNode("span", _hoisted_7, _toDisplayString(notes.action), 1),
                    _createTextVNode(" -  "),
                    _createElementVNode("span", _hoisted_8, [
                      _createTextVNode("Shift: "),
                      _createElementVNode("strong", null, _toDisplayString(notes.shiftCode), 1)
                    ]),
                    _createTextVNode("  ")
                  ]),
                  _createElementVNode("div", {
                    class: _normalizeClass(["py-2", [ notes.note == '' || notes.note == null ? 'd-none' : '']])
                  }, [
                    _hoisted_9,
                    _createTextVNode(" " + _toDisplayString(notes.note), 1)
                  ], 2)
                ]))
              }), 128))
            : _createCommentVNode("", true),
          (_ctx.notesData != null && _ctx.notesData.length > 0 && _ctx.isOtherNoteTemplate )
            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.notesData, (notes) => {
                return (_openBlock(), _createElementBlock("div", { key: notes }, [
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("span", _hoisted_11, _toDisplayString(notes.createdDate) + " ", 1),
                    _createElementVNode("span", _hoisted_12, _toDisplayString(notes.userLastName) + ", " + _toDisplayString(notes.userFirstName) + " - ", 1),
                    _createElementVNode("span", null, _toDisplayString(notes.noteContent), 1)
                  ])
                ]))
              }), 128))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_13, [
      _createElementVNode("div", _hoisted_14, [
        _hoisted_15,
        _withDirectives(_createElementVNode("textarea", {
          id: "txtNote",
          class: "form-control",
          rows: "3",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.noteTxt) = $event)),
          placeholder: "Start Typing...",
          onKeyup: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.sendNoteText && _ctx.sendNoteText(...args)))
        }, null, 544), [
          [_vModelText, _ctx.noteTxt]
        ]),
        _createElementVNode("h5", _hoisted_16, [
          _createTextVNode("Remaining: "),
          _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.nMaxLength - (_ctx.noteTxt != undefined || _ctx.noteTxt!= "" ? _ctx.noteTxt.length: 0)), 1)
        ])
      ])
    ]),
    (_ctx.isShowAddNoteBtn)
      ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
          _createElementVNode("div", _hoisted_19, [
            _createVNode(_component_neu_button, {
              type: "button",
              fill: "raised",
              id: "btnSaveNote",
              onClick: _ctx.createSendNote
            }, {
              default: _withCtx(() => [
                _createVNode(_component_font_awesome_icon, {
                  icon: ['fas', 'save'],
                  size: "sm",
                  class: "mr-2"
                }),
                _createTextVNode(" Add Note ")
              ]),
              _: 1
            }, 8, ["onClick"])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}